import { Observable, Subject } from 'rxjs';

import { OverlayRef } from '../core/core.module';
import {
  DialogContainerAnimationState,
  DialogContainerComponent,
} from './dialog-container/dialog-container.component';

export class DialogRef<T = any, DialogResult = any> {
  public componentInstance: T;
  public afterClosed: Observable<DialogResult>;

  private afterClosedSubject: Subject<DialogResult> = new Subject();
  private result: DialogResult | undefined;

  constructor(private overlayRef: OverlayRef, public containerInstance: DialogContainerComponent) {
    this.afterClosed = this.afterClosedSubject.asObservable();

    containerInstance.animationStateChange.subscribe((state: DialogContainerAnimationState) => {
      if (state === 'exit-start') {
        // Transition the backdrop in parallel with the dialog.
        this.overlayRef.detachBackdrop();
      } else if (state === 'exit') {
        this.overlayRef.dispose();
        this.afterClosedSubject.next(this.result);
        this.afterClosedSubject.complete();
        // @ts-ignore
        delete this.componentInstance;
        delete this.result;
      }
    });
  }

  public setContainerWidth(width: string): void {
    this.containerInstance.dialogConfig = { ...this.containerInstance.dialogConfig, width };
    this.containerInstance.detectChanges();
  }

  public close(dialogResult?: DialogResult): void {
    this.result = dialogResult;
    return this.containerInstance.close();
  }
}
